import { ReactNode } from "react"
import { css, cx } from "@emotion/css"
import { standardScrollBar } from "../../../styles"

export function RootLayout({ children }: { children: ReactNode }) {
  return (
    <div className={cx(standardScrollBar.root, styles.root)}>{children}</div>
  )
}

const styles = {
  root: css`
    max-height: 416px;
    padding: var(--spacing-xl);
    display: flex;
    flex-direction: column;
    background-color: var(--black-opacity);
    white-space: nowrap;
  `,
}
